import { Pipe, PipeTransform, OnDestroy } from '@angular/core'
import { DatePipe as AngularDatePipe } from '@angular/common'
import { Subscription } from 'rxjs'
import { I18nConfigService } from '../../../core/services/i18n-config.service'

@Pipe({
    name: 'appLocaleDate',
    standalone: false
})
export class AppLocaleDatePipe implements PipeTransform, OnDestroy {
  private angularDatePipe: AngularDatePipe
  subscriptions: Subscription[] = [
    this.i18nConfigService.selectedLanguage$.subscribe(selectedLanguage => {
      this.angularDatePipe = new AngularDatePipe(selectedLanguage)
    }),
  ]
  constructor (
    private i18nConfigService: I18nConfigService,
  ) {}
  transform (value: Date | string | number | null | undefined, format?:string, timezone?:string): unknown {
    return this.angularDatePipe.transform(value, format, timezone)
  }
  ngOnDestroy (): void {
    this.subscriptions.forEach(subscription=>subscription.unsubscribe())
  }

}
